import { FormLabel } from "@vega-core/components/Form/Layout/FormLabel";
import { m } from "@vega-core/paraglide/messages";

type ScheduledTimeInputProps = {
  id: string;
  onChange: (value: string) => void;
  value: string;
};

export function ScheduledTimeInput({
  id,
  onChange,
  value,
}: ScheduledTimeInputProps) {
  return (
    <div className="flex flex-col">
      <FormLabel
        forName={id}
        label={m.coInvestments_draftEmail_sendTime_label()}
      />
      <input
        className="body-base-regular min-h-11 rounded-companyBorderRadius border border-border/primary bg-background/primary px-3 text-text/primary outline-none focus:border-brand-default focus:ring-0 focus:ring-offset-0 hover:border-brand-default focus-within:outline focus-within:outline-2 focus-within:outline-offset-0 focus-within:outline-brand-default [&::-webkit-calendar-picker-indicator:focus]:outline-none"
        data-testid={id}
        id={id}
        onChange={(event) => onChange(event.target.value)}
        type="time"
        value={value}
      />
    </div>
  );
}
